import {httpService} from "@/modules/common/services";

const updateTrackingSettings = (businessUid, data) => {
  data.new_api = true;
  return httpService.put(`business/client_tracking/v1/settings/${businessUid}/`, data)
}

const getTrackingSettings = () => {
  return httpService.get('/business/client_tracking/v1/settings', {new_api: true})
}

const updateNotificationSettings = (data) => {
  return httpService.post('settings/update_notifications_settings',{settings:data})
}

const updateInboxNotificationSettings = (data) => {
  return httpService.post('settings/update_notifications_settings', data)
}

const getIntegrationsSettings = () => {
  return httpService.get('settings/integrations/settings')
}

const update = (data) => {
  return httpService.put('settings',data)
}

const getBusinessSettings = (businessId) => {
  return httpService.get(`settings/businesses/${businessId}?teams_view_filter=all`)
}

const updateBusinessSettings = (businessId, params) => {
  return httpService.put(`settings/businesses/${businessId}?teams_view_filter=all`, params)
}

const get = (data) => {
  const url = `settings/${data && data.path ? data.path : ''}`
  return httpService.get(url)
}

const updatePlatformBusinessSetting = (businessId, params) => {
  const url = `/businesses/${businessId}`
  return httpService.put(url, params);
}

const saveStaffContentDisplaySettings = (staffId, payload) => {
  const url = `business/scheduling/v1/calendar_settings`
  return httpService.put(url, {...payload, new_api: true});
}

export const settingsService = {
  update,
  updateNotificationSettings,
  getIntegrationsSettings,
  getBusinessSettings,
  updateBusinessSettings,
  updateInboxNotificationSettings,
  get,
  getTrackingSettings,
  updateTrackingSettings,
  updatePlatformBusinessSetting,
  saveStaffContentDisplaySettings,
};
